import IconButton from 'components/@extended/IconButton';
import { PersonAdd as PersonAddIcon } from 'components/icons';
import { MouseEventHandler } from 'react';
import { t } from 'utils/getTranslations.ts';

export function EmployeeAddIconButton({ onClick }: { onClick?: MouseEventHandler<HTMLButtonElement> }) {
    return (
        <IconButton onClick={onClick} size="small" className="ml-2" title={t('add-employees')}>
            <PersonAddIcon fontSize="small" />
        </IconButton>
    );
}
